import {Component} from 'react';
import h from 'react-hyperscript';
import './MobileMenu.scss';
import {subhead} from 'Components/Typography/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';

class MobileMenu extends Component {
  constructor(props) {
    super(props);
    this.changeContent = this.changeContent.bind(this);

    this.state = {open: false};
  }

  changeContent(e) {
    this.setState({open: false});
    if (this.props.changeContent) {
      this.props.changeContent(e);
    }
  }

  handleOpen(e) {
    this.setState({open: true});
    if (this.props.handleMobileMenuOpen) {
      this.props.handleMobileMenuOpen(e);
    }
  }

  render() {
    const {id, menuList, anchorEl, selectedIndex, disableIdx} = this.props;
    return (
      h('div', {
        className: `mobile-menu__container hide--desktop`,
        id: id,
      }, [
        h(List, {
          className: 'mobile-menu__trigger',
        }, [
          h(ListItem, {
            key: 'mobile-menu-trigger',
            button: true,
            ariahaspopup: 'true',
            ariacontrols: 'lock-menu',
            arialabel: 'Label',
            onClick: (e) => this.handleOpen(e),
          }, [
            h(ListItemText, {
              primary: menuList[selectedIndex].title,
            }, null),
            h('span', {
              className: 'material-icons',
            }, 'keyboard_arrow_down'),
          ]),
        ]),

        h(Menu, {
          key: 'mobile-menu__key',
          keepMounted: true,
          className: 'mobile-menu',
          anchorEl: anchorEl,
          open: Boolean(anchorEl) ? this.state.open : false,
          onClose: (e) => {
            this.props.handleMobileMenuClose(e);
          },
        }, this.props.menuList.map((item, i) => {
          const disabled = disableIdx && i > disableIdx.length;
          return h(ListItem, {
            key: `${i}--listItem`,
            className: 'mobile-menu-item',
            datatab: i,
            disabled: disabled,
            onClick: (e) => {
              if (disabled) {
                return;
              }
              this.changeContent(e);
            },
          }, h(subhead, null, item.title));
        })),
      ])
    );
  }
}

export default MobileMenu;
